// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store.js'
import BootstrapVue from 'bootstrap-vue'
import './assets/css/main.css'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import Vuelidate from "vuelidate";
import i18n from './i18n'
import 'vue-awesome/icons/flag'

import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
import VueApexCharts from 'vue-apexcharts'

const moment = require('vue-moment');
moment.suppressDeprecationWarnings = true;

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.setIcon('success', 'i', {'class': 'fa fa-check-circle-o'})
miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const optionsToast = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
//  VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, optionsToast)

const fb = require('./firebaseConfig.js')

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.component('icon', Icon)
Vue.use(Vuelidate);
Vue.use(moment);
Vue.component('apexchart', VueApexCharts)
//Vue.use(require('vue-moment'));


let app;

fb.auth.onAuthStateChanged(user => {
  if (!app) {
      app = new Vue({
        el: '#app',
        router,
        store,
        i18n,
        render: h => h(App)
      })
  }
})





// WEBPACK FOOTER //
// ./src/main.js